import Detail from '../../../../../components/Detail';
import InfoPopUp from '../../../../../components/InfoPopUp';
import { formatUSD } from '../../../../../helpers/formats';
import useTotalAccumulatedVoSpool from '../../../../../hooks/web3/vault/useTotalAccumulatedVoSpool';

const TOTAL_SPOOL_EMITTED = 741_000;
const EMISSION_DURATION = 13; // 13 weeks
const SPOOL_PER_WEEK = TOTAL_SPOOL_EMITTED / EMISSION_DURATION;

const SpoolPerVoSpool = () => {
    const { totalAccumulatedVoSpool } = useTotalAccumulatedVoSpool();

    return (
        <Detail
            title={
                <>
                    <span>$SPOOL per voSPOOL (Next Epoch)</span>
                    <InfoPopUp>
                        <div>
                            $SPOOL per voSPOOL is calculated according to two factors.
                        </div>

                        <div className='mt'>
                            According to SIP - 1.36 currently 57,000 SPOOL will be emitted
                            per week.
                        </div>

                        <div className='mt'>
                            57,000 $SPOOL is then divided across the voSPOOL in
                            circulation.
                        </div>
                    </InfoPopUp>
                </>
            }
            value={
                <>
                    {totalAccumulatedVoSpool
                        ? formatUSD(SPOOL_PER_WEEK / +totalAccumulatedVoSpool || 0)
                        : '0.00'}{' '}
                    $SPOOL
                </>
            }
        />
    );
};

export default SpoolPerVoSpool;
